export function restoreFocusAfterDismiss(banner: HTMLElement | null, returnFocusIds?: string[]) {
  if (!banner?.contains(document.activeElement) || !returnFocusIds) return

  let target: HTMLElement | null = null

  for (const id of returnFocusIds) {
    const candidate = document.getElementById(id)
    if (candidate?.checkVisibility()) {
      target = candidate
      break
    }
  }

  target?.focus()
}
